export function downloadGeneratedReport(id, filename) {
    if (!id) {
        return;
    }

    const downloadUrl = `${window.origin}/download-csv/${id}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    if (filename) {
        link.setAttribute("download", filename);
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
